import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { AuthService } from '../auth.service';
import { HttpClient, HttpHeaders }  from "@angular/common/http";

import { CaptchaModule } from 'primeng/captcha';
import { ToastModule } from 'primeng/toast';
import { CheckboxModule } from 'primeng/checkbox';

import { CaptchaService } from '../captcha.service';

import { Observable, from } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls:  ['./signup.component.css']
})


export class SignupComponent implements OnInit {

   public registrationForm: FormGroup;      // state of the registration form
   displayPopupRegistrationOK: boolean;
   checkAgree: boolean = false;
   checkCaptcha: boolean = false;
   recaptcha;

   // siteKeyCaptcha : String = "6Le8zpMUAAAAAHB3AhpC1f22YahmbE5XA-xQ7lqv"
   // siteSecretCaptcha : String = "6Le8zpMUAAAAAJO7-Q5Sf4_D_BiGu4X70JWeevYy"


   constructor(
      private fb: FormBuilder,
      private auth: AuthService,
      private router: Router,
      private http: HttpClient,
      private captcha: CaptchaService
   ) {}

   ngOnInit() {
     this.initForm();
     this.recaptcha = (window as any).grecaptcha;
   }

   // initialize the registration form
   initForm() {
      this.registrationForm = this.fb.group({
        'username': ['', Validators.required],
        'email': ['', Validators.required],
        'surname': ['', Validators.required],
        'name': ['', Validators.required],
        'password1': ['', Validators.required],
        'password2': ['', Validators.required],
      });
   }  // end initForm

   onSubmitRegistration(value: any) {
      const username = value.username;
      const email = value.email;
      const surname = value.surname;      // surname or company name
      const name = value.name;
      const password1 = value.password1;
      const password2 = value.password2;
      // alert("Going to register...");      // DEBUG
      if ( password1 !== password2 ) {
         alert("PLEASE CONTROL THE ENTERED PASSWORDS \n AND RETRY");
         return;
      };
      const password = password1;

      // call the AuthService register method, that returns an Observable<any>
      this.auth.register(username, email, surname, name, password).subscribe(
         data => {
            // alert("YOU SUCCESSFULLY REGISTERED");
            this.displayPopupRegistrationOK=true;
            // Cognito will return an object of shape:
            // { user: CognitoUser, userConfirmed: boolean, userSub: string }
            console.log("Successful registration." + "\n" +
                        "User data: " + JSON.stringify(data, null, 2));
         },
         error => {
            alert("REGISTRATION ERROR");
            console.log("Failed registration: error = " + JSON.stringify(error, null, 2));
         }
      );

   }  // end onSubmitRegistration

   redirectToConfirm() {
     this.displayPopupRegistrationOK=false;
     this.router.navigate(['/confirm']);    // go to the confirm page/component
   }



   ccb(response){
     console.log(response)
     this.captcha.checkCaptcha(response.response).subscribe(
       data => {
         console.log("Successfull checked reCaptcha = " + JSON.stringify(data, null, 2))
         if (data.success==true){
           this.checkCaptcha=true;
         }
       },
       error => {
         alert("CHECKRECAPTCHA ERROR");
       }
     )
   }

}  // end SignupComponent
